import { render, staticRenderFns } from "./FaqQuestionAnswer.vue?vue&type=template&id=7e218a52&"
import script from "./FaqQuestionAnswer.vue?vue&type=script&lang=js&"
export * from "./FaqQuestionAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports